import { RootState } from 'store/store';

export const selectPermissionsMap = (state: RootState) => state.permissions.rolePermissions;
